import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#D72D2D" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center black bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/chibopcanada/"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Chibop Facebook"
              />
            </CFLink>
            <CFLink
              target="_blank"
              href="https://www.instagram.com/hashtag_chibop/?hl=en"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Chibop Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#D72D2D" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter black bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/chibopcanada/"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Chibop Facebook"
              />
            </CFLink>
            <CFLink
              target="_blank"
              href="https://www.instagram.com/hashtag_chibop/?hl=en"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Chibop Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
